import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function OrderingProcess() {
  return <div className="bg-navy-900 border-t border-white/10 py-16 sm:py-20" data-id="element-135">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 lg:items-start" data-id="element-137">
          {/* Left Column: Title & Description */}
          <div className="lg:col-span-5" data-id="element-138">
            <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-cg-orange-600 mb-3" data-id="element-139">
              How It Works
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4" data-id="element-140">
              Request-Based Ordering
            </h2>
            <p className="text-sm text-steel-300 leading-relaxed" data-id="element-141">
              All orders are placed through a structured request process. No
              payment is taken upfront. Our team reviews each request and
              confirms pricing, fulfilment, and delivery before proceeding.
            </p>
          </div>

          {/* Right Column: Steps & CTA */}
          <div className="lg:col-span-7" data-id="element-142">
            <div className="space-y-6 mb-8" data-id="element-143">
              <div className="flex items-start gap-4" data-id="element-144">
                <span className="text-2xl font-bold text-cg-orange-600/30 leading-none mt-0.5 flex-shrink-0 w-8" data-id="element-145">
                  01
                </span>
                <div data-id="element-146">
                  <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-1" data-id="element-147">
                    Browse & Select
                  </h3>
                  <p className="text-sm text-steel-300 leading-relaxed" data-id="element-148">
                    Explore our inventory by category. Review specifications and
                    product details.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-149">
                <span className="text-2xl font-bold text-cg-orange-600/30 leading-none mt-0.5 flex-shrink-0 w-8" data-id="element-150">
                  02
                </span>
                <div data-id="element-151">
                  <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-1" data-id="element-152">
                    Submit a Request
                  </h3>
                  <p className="text-sm text-steel-300 leading-relaxed" data-id="element-153">
                    Complete the order request form on any product page with
                    your quantities and requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-154">
                <span className="text-2xl font-bold text-cg-orange-600/30 leading-none mt-0.5 flex-shrink-0 w-8" data-id="element-155">
                  03
                </span>
                <div data-id="element-156">
                  <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-1" data-id="element-157">
                    Review & Confirm
                  </h3>
                  <p className="text-sm text-steel-300 leading-relaxed" data-id="element-158">
                    Our team confirms pricing, fulfilment, and delivery, then
                    coordinates to your requirements.
                  </p>
                </div>
              </div>
            </div>

            <Link to="/inventory" className="inline-flex items-center gap-2 px-6 py-3 border border-steel-400 hover:border-cg-orange-600 text-white hover:text-cg-orange-600 font-bold uppercase tracking-wider text-xs rounded-sm transition-all group" data-id="element-159">
              Browse Inventory
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-160" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}